import { DcaScenarioSelector } from 'components/well-page-content/decline-curve-analysis/dca-scenario-selector';
import style from './dca-scenario-selection.module.scss';
import { Close } from '@carbon/react/icons';

interface DcaScenarioSelectionProps {
  onClose: () => void;
}

export const DcaScenarioSelection = ({
  onClose,
}: DcaScenarioSelectionProps) => {
  return (
    <div className={style.root}>
      <div className={style.header}>
        <h2 className={style.title}>DCA Scenarios</h2>
        <p className={style.description}>
          Select a DCA scenario to apply to DCA analysis.
        </p>

        <Close className={style.closeButton} onClick={onClose} />
      </div>
      <div className={style.scrollArea}>
        <DcaScenarioSelector formClassName={style.dcaScenarioForm} />
      </div>
    </div>
  );
};
